export interface IQuery { }

export class ExpenseAccountByIdQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Costs.Queries.ExpenseAccountByIdQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	ExpenseId: string

	constructor (workspaceId: number, strategyId: string, expenseId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.ExpenseId = expenseId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Costs.Queries.ExpenseAccountByIdQueryV1, TCh.Domain.Quest'
	}

}

export class ExpenseAccountsByStrategyIdQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Costs.Queries.ExpenseAccountsByStrategyIdQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string

	constructor (workspaceId: number, strategyId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Costs.Queries.ExpenseAccountsByStrategyIdQueryV1, TCh.Domain.Quest'
	}

}

export class ManageCostsPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Costs.Queries.ManageCostsPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string

	constructor (workspaceId: number, strategyId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Costs.Queries.ManageCostsPageQueryV1, TCh.Domain.Quest'
	}

}

